import type { VendorPersonType } from '@econtractor/types';
import TableEmptyRow from 'components/others/TableEmptyRow';
import VendorPersonsTableRow from './VendorPersonsTableRow';

interface VendorPersonsTableBodyProps {
    rows: VendorPersonType[];
    onEdit: (row: VendorPersonType) => void;
    onDelete: (row: VendorPersonType) => void;
    onOpenContacts: (row: VendorPersonType) => void;
    onSetPrimary: (row: VendorPersonType, isPrimary: boolean) => void;
}

const VendorPersonsTableBody = ({
    rows,
    onEdit,
    onDelete,
    onOpenContacts,
    onSetPrimary,
}: VendorPersonsTableBodyProps) => (
    <tbody>
        {!rows.length ? (
            <TableEmptyRow colSpan={4} />
        ) : (
            rows.map((row) => (
                <VendorPersonsTableRow
                    key={row.ID}
                    row={row}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    onOpenContacts={onOpenContacts}
                    onSetPrimary={onSetPrimary}
                />
            ))
        )}
    </tbody>
);

export default VendorPersonsTableBody;
